/* SteamZap assistant widget — talks to the steamzap-assistant edge function.
   Usage: <div data-sz-assistant data-endpoint="…" data-key="…" data-name="Zap" …></div>
   data-mode="inline" (default, full chat box) or "launcher" (floating button + panel). */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'sz-assistant:';
  var MAX_HISTORY = 24;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function inline(s) {
    return s
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/`([^`]+)`/g, '<code>$1</code>')
      .replace(/(https?:\/\/[^\s<]+[^\s<.,)])/g, '<a href="$1" target="_blank" rel="noopener">$1</a>')
      .replace(/(^|[^\/\w])([\w.+-]+@[\w-]+\.[\w.-]+\w)/g, '$1<a href="mailto:$2">$2</a>');
  }
  /* Minimal, safe Markdown: paragraphs, **bold**, `code`, numbered and bulleted lists, links. */
  function renderMarkdown(text) {
    var lines = escapeHtml(text).split('\n');
    var html = '', inUl = false, inOl = false, para = [];
    function flushPara() { if (para.length) { html += '<p>' + para.join('<br>') + '</p>'; para = []; } }
    function closeLists() { if (inUl) { html += '</ul>'; inUl = false; } if (inOl) { html += '</ol>'; inOl = false; } }
    lines.forEach(function (raw) {
      var l = raw.trim();
      var ol = l.match(/^(\d+)[.)]\s+(.*)/);
      var ul = l.match(/^[-*•]\s+(.*)/);
      if (ol) {
        flushPara(); if (inUl) { html += '</ul>'; inUl = false; }
        if (!inOl) { html += '<ol>'; inOl = true; }
        html += '<li>' + inline(ol[2]) + '</li>';
      } else if (ul) {
        flushPara(); if (inOl) { html += '</ol>'; inOl = false; }
        if (!inUl) { html += '<ul>'; inUl = true; }
        html += '<li>' + inline(ul[1]) + '</li>';
      } else if (!l) {
        flushPara(); closeLists();
      } else {
        closeLists(); para.push(inline(l));
      }
    });
    flushPara(); closeLists();
    return html;
  }

  function Assistant(root) {
    var self = this;
    this.root = root;
    this.cfg = {
      endpoint: root.getAttribute('data-endpoint') || '',
      key: root.getAttribute('data-key') || '',
      name: root.getAttribute('data-name') || 'Zap',
      intro: root.getAttribute('data-intro') || '',
      placeholder: root.getAttribute('data-placeholder') || 'Ask about your shoes…',
      disclaimer: root.getAttribute('data-disclaimer') || '',
      label: root.getAttribute('data-label') || 'ASK ZAP',
      mode: root.getAttribute('data-mode') || 'inline',
      suggestions: (root.getAttribute('data-suggestions') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean),
      storageKey: STORAGE_PREFIX + (root.getAttribute('data-storage') || 'default')
    };
    this.messages = this.load();
    this.ctrl = null;
    this.build();
    this.renderAll();
    if (this.cfg.mode === 'launcher') {
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.toggle(false); });
    }
  }

  Assistant.prototype.load = function () {
    try { var raw = sessionStorage.getItem(this.cfg.storageKey); return raw ? JSON.parse(raw) : []; } catch (e) { return []; }
  };
  Assistant.prototype.save = function () {
    try { sessionStorage.setItem(this.cfg.storageKey, JSON.stringify(this.messages.slice(-MAX_HISTORY))); } catch (e) { /* private mode */ }
  };

  Assistant.prototype.build = function () {
    var self = this, c = this.cfg;
    var box = el('div', 'sz-ai');
    var head = el('div', 'sz-ai__head');
    head.appendChild(el('span', 'sz-ai__avatar', '⚡'));
    var names = el('div', 'sz-ai__names');
    names.appendChild(el('div', 'sz-ai__name', c.name));
    names.appendChild(el('div', 'sz-ai__status', 'SteamZap coach · answers in seconds'));
    head.appendChild(names);
    if (c.mode === 'launcher') {
      var close = el('button', 'sz-ai__close', '✕');
      close.type = 'button'; close.setAttribute('aria-label', 'Close chat');
      close.addEventListener('click', function () { self.toggle(false); });
      head.appendChild(close);
    }
    box.appendChild(head);

    this.log = el('div', 'sz-ai__log');
    this.log.setAttribute('role', 'log');
    this.log.setAttribute('aria-live', 'polite');
    box.appendChild(this.log);

    this.chips = el('div', 'sz-ai__chips');
    c.suggestions.forEach(function (s) {
      var b = el('button', 'sz-ai__chip', s); b.type = 'button';
      b.addEventListener('click', function () { self.send(s); });
      self.chips.appendChild(b);
    });
    box.appendChild(this.chips);

    var form = el('form', 'sz-ai__form');
    this.input = el('textarea', 'sz-ai__input');
    this.input.rows = 1;
    this.input.placeholder = c.placeholder;
    this.input.setAttribute('aria-label', 'Your message');
    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : self.submit(); }
    });
    this.input.addEventListener('input', function () {
      self.input.style.height = 'auto';
      self.input.style.height = Math.min(160, self.input.scrollHeight) + 'px';
    });
    this.sendBtn = el('button', 'sz-ai__send', 'SEND');
    this.sendBtn.type = 'submit';
    form.appendChild(this.input);
    form.appendChild(this.sendBtn);
    form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    box.appendChild(form);

    var foot = el('div', 'sz-ai__foot');
    foot.appendChild(el('span', null, c.disclaimer));
    var reset = el('button', 'sz-ai__reset', 'Start over'); reset.type = 'button';
    reset.addEventListener('click', function () { self.reset(); });
    foot.appendChild(reset);
    box.appendChild(foot);
    this.box = box;

    if (c.mode === 'launcher') {
      this.panel = el('div', 'sz-ai-panel');
      this.panel.setAttribute('aria-hidden', 'true');
      this.panel.appendChild(box);
      this.launcher = el('button', 'sz-ai-launcher');
      this.launcher.type = 'button';
      this.launcher.setAttribute('aria-expanded', 'false');
      this.launcher.innerHTML = '<span class="sz-ai-launcher__bolt" aria-hidden="true">⚡</span><span>' + escapeHtml(c.label) + '</span>';
      this.launcher.addEventListener('click', function () { self.toggle(); });
      this.root.appendChild(this.launcher);
      this.root.appendChild(this.panel);
    } else {
      this.root.appendChild(box);
    }
  };

  Assistant.prototype.toggle = function (open) {
    if (!this.panel) return;
    var isOpen = this.panel.classList.contains('is-open');
    open = typeof open === 'boolean' ? open : !isOpen;
    this.panel.classList.toggle('is-open', open);
    this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    this.launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.launcher.classList.toggle('is-open', open);
    if (open) { this.scroll(); this.input.focus(); }
  };

  Assistant.prototype.bubble = function (role, text) {
    var b = el('div', 'sz-ai__msg sz-ai__msg--' + role);
    this.setBubble(b, text);
    this.log.appendChild(b);
    this.scroll();
    return b;
  };
  Assistant.prototype.setBubble = function (b, text) {
    if (b.classList.contains('sz-ai__msg--user')) b.textContent = text;
    else b.innerHTML = renderMarkdown(text);
  };
  Assistant.prototype.scroll = function () { this.log.scrollTop = this.log.scrollHeight; };

  Assistant.prototype.renderAll = function () {
    var self = this;
    this.log.innerHTML = '';
    if (this.cfg.intro) this.bubble('assistant', this.cfg.intro);
    this.messages.forEach(function (m) { self.bubble(m.role, m.content); });
    this.chips.style.display = this.messages.length ? 'none' : '';
  };

  Assistant.prototype.reset = function () {
    if (this.ctrl) this.ctrl.abort();
    this.messages = [];
    this.save();
    this.renderAll();
    this.input.value = '';
    this.input.focus();
  };

  Assistant.prototype.setBusy = function (busy) {
    this.sendBtn.disabled = busy;
    this.sendBtn.textContent = busy ? '…' : 'SEND';
    this.input.disabled = busy;
  };

  Assistant.prototype.headers = function () {
    var h = { 'Content-Type': 'application/json' };
    if (this.cfg.key) { h.apikey = this.cfg.key; h.Authorization = 'Bearer ' + this.cfg.key; }
    return h;
  };

  Assistant.prototype.submit = function () {
    var text = this.input.value.trim();
    if (!text) return;
    this.input.value = '';
    this.input.style.height = 'auto';
    this.send(text);
  };

  Assistant.prototype.send = function (text) {
    var self = this;
    if (!text || this.ctrl) return;
    if (!this.cfg.endpoint) { this.bubble('assistant', 'The assistant endpoint is not configured yet.').classList.add('is-error'); return; }
    this.chips.style.display = 'none';
    this.messages.push({ role: 'user', content: text });
    this.bubble('user', text);
    var bubble = this.bubble('assistant', '');
    bubble.classList.add('is-typing');
    this.setBusy(true);
    var ctrl = new AbortController();
    this.ctrl = ctrl;
    var reply = '';

    fetch(this.cfg.endpoint, {
      method: 'POST',
      headers: this.headers(),
      body: JSON.stringify({ messages: this.messages.slice(-MAX_HISTORY) }),
      signal: ctrl.signal
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.error || ('HTTP ' + res.status)); });
      }
      var ct = res.headers.get('content-type') || '';
      if (ct.indexOf('text/event-stream') === -1) {
        return res.json().then(function (j) { if (j.error) throw new Error(j.error); reply = j.reply || ''; });
      }
      var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
      function handle(line) {
        if (line.indexOf('data:') !== 0) return;
        var obj;
        try { obj = JSON.parse(line.slice(5).trim()); } catch (e) { return; }
        if (obj.error) throw new Error(obj.error);
        if (obj.delta) {
          reply += obj.delta;
          bubble.classList.remove('is-typing');
          self.setBubble(bubble, reply);
          self.scroll();
        }
      }
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) { if (buf) buf.split('\n').forEach(handle); return; }
          buf += dec.decode(r.value, { stream: true });
          var parts = buf.split('\n\n'); buf = parts.pop();
          parts.forEach(function (chunk) { chunk.split('\n').forEach(handle); });
          return pump();
        });
      }
      return pump();
    }).then(function () {
      if (!reply) throw new Error('No reply. Please try again.');
      bubble.classList.remove('is-typing');
      self.setBubble(bubble, reply);
      self.messages.push({ role: 'assistant', content: reply });
      self.save();
    }).catch(function (err) {
      if (err && err.name === 'AbortError') {
        if (reply) { self.messages.push({ role: 'assistant', content: reply }); self.save(); } else { bubble.remove(); self.messages.pop(); }
        return;
      }
      bubble.classList.remove('is-typing');
      bubble.classList.add('is-error');
      self.setBubble(bubble, (err && err.message) || 'Something went wrong. Please try again.');
      self.messages.pop();
      self.input.value = text;
    }).then(function () {
      self.setBusy(false);
      self.ctrl = null;
      self.scroll();
      if (self.cfg.mode !== 'launcher' || self.panel.classList.contains('is-open')) self.input.focus();
    });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sz-assistant]'), function (root) {
      if (root.__szAssistant) return;
      root.__szAssistant = new Assistant(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.SteamZapAssistant = { init: init, renderMarkdown: renderMarkdown };
})();
